import { NoteReviewStateInterface } from './interfaces';
import { RootState } from '../../';

export const selectNoteReviewState = (state: RootState): NoteReviewStateInterface =>
  state.noteReview;

export const selectNoteReview = (state: RootState) => selectNoteReviewState(state).review;

export const selectNoteReviewStatus = (state: RootState) => selectNoteReviewState(state).status;

export const selectShowPoorReviewModal = (state: RootState) =>
  selectNoteReviewState(state).showPoorReviewModal ?? false;
